import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const areaSelectionSlice = createSlice({
  name: 'areaSelection',
  initialState: {
    layersData: [],
    refObj: { isRefresh: false, count: 0 }
  },
  reducers: {
    areaSelectionReducer: (state, action) => {
      state.layersData = action.payload.layersData;
      return state;
    },
    areaSelectionRefreshReducer: (state, action) => {
      state.refObj.count++;
      state.refObj.isRefresh = action.payload.isRefresh;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { areaSelectionReducer, areaSelectionRefreshReducer } = areaSelectionSlice.actions
export default areaSelectionSlice.reducer 
